import { createGlobalStyle } from 'styled-components';

/**
 * App-wide thin scrollbars: theme-aware. WebKit: thumb hidden until hover/focus-within on the scrolling element.
 * Firefox: thin scrollbar with low-contrast thumb (no hover API for scrollbar parts).
 */
export const AppScrollbarsGlobalStyle = createGlobalStyle`
    * {
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => {
            const dark = theme?.colors?.background?.default === '#141414';
            return dark ? 'rgba(255,255,255,0.14) transparent' : 'rgba(0,0,0,0.12) transparent';
        }};
    }
    *::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    *::-webkit-scrollbar-track {
        background: transparent;
    }
    *::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 100px;
        border: 2px solid transparent;
        background-clip: padding-box;
        transition: background-color 0.2s ease;
    }
    *:hover::-webkit-scrollbar-thumb,
    *:focus-within::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) =>
            theme?.colors?.background?.default === '#141414' ? 'rgba(255,255,255,0.28)' : 'rgba(0,0,0,0.28)'};
        border: 2px solid transparent;
        background-clip: padding-box;
    }
`;
